import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { SellFlow } from "@/components/SellFlow";
import { latestAdsQueryOptions } from "@/lib/latest-ads";

export const Route = createFileRoute("/skapa")({
  head: () => ({
    meta: [
      { title: "Skapa annons – fota och publicera gratis | Sellavo" },
      {
        name: "description",
        content:
          "Skapa din annons på Sellavo: fota prylen, få färdig text och prisförslag av oss och publicera. Dina utkast sparas automatiskt.",
      },
      { property: "og:title", content: "Skapa annons – fota och publicera gratis | Sellavo" },
      {
        property: "og:description",
        content:
          "Fota prylen, få färdig annonstext och prisförslag och publicera gratis. Utkast sparas automatiskt.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sellavo.com/skapa" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/skapa" }],
  }),

  // Prefetch utan await: sidan börjar strömma direkt och annonslistan
  // fylls i när svaret kommer (den renderas i en egen Suspense-gräns).
  loader: ({ context }: { context: { queryClient: QueryClient } }) => {
    void context.queryClient.prefetchQuery(latestAdsQueryOptions());
  },

  component: () => <SellFlow variant="create" />,
});
